import React, { memo, useCallback } from 'react';
import { DayPicker } from 'react-day-picker';
import { DayContent } from './DayContent';
import { formatDateFromRange } from './helpers';
import { DatePickerMode } from './types';
export const RangeCalendar = memo(({ date, disabledDays, onChange, CaptionComponent, setInputValue }) => {
    const handleOnSelectRange = useCallback((range) => {
        const { from, to } = range ?? {};
        const nextInputValue = !range || (!from && !to)
            ? ''
            : `${formatDateFromRange(from)} - ${formatDateFromRange(to)}`;
        onChange(range);
        setInputValue(nextInputValue);
    }, [onChange, setInputValue]);
    return (React.createElement(DayPicker, { disabled: disabledDays, mode: DatePickerMode.RANGE, defaultMonth: date?.from, selected: date, onSelect: handleOnSelectRange, components: {
            Caption: CaptionComponent,
            DayContent,
        } }));
});
RangeCalendar.displayName = 'RangeCalendar';
